export interface ELApproverData {
  UserName: string;
  UserFullName: string;
  UserRole: string;
  ApprovalStatus: string;
  Message: string;
  UpdatedDate: string;
  COIApprover?: "Y" | "N" | null;
}

export const COI_REGISTRY_REVIEWERS_LABEL = "COI Registry Reviewers";

/**
 * Collapses every COIApprover='Y' row into a single "COI Registry Reviewers"
 * row, since they always share one status (bulk-resolved together the
 * moment any one of them decides) -- individual identity is captured on the
 * conflict match record itself, not needed on this approver-status popup.
 *
 * @param approvers - Raw approver rows for this EL.
 */
export const groupCOIApprovers = (approvers: ELApproverData[]): ELApproverData[] => {
  const coiRows = approvers.filter((approver) => approver.COIApprover === "Y");
  const regularRows = approvers.filter((approver) => approver.COIApprover !== "Y");

  if (coiRows.length === 0) {
    return regularRows;
  }

  const [representativeRow] = coiRows;
  return [
    {
      ...representativeRow,
      UserFullName: COI_REGISTRY_REVIEWERS_LABEL,
      UserRole: "",
    },
    ...regularRows,
  ];
};
